import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=766d3f9b&scoped=true"
import script from "./area-select.vue?vue&type=script&lang=js"
export * from "./area-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d3f9b",
  null
  
)

export default component.exports